<template>
	<el-tabs>
		<el-tab-pane >
			<span slot="label"><i class="el-icon-document-remove"></i>{{value.ming}}组件</span>
			
			<div class="zidingyi_pd">
				<!-- <div style="padding-top: 20px;">
					<div style="margin-top: 20px">
						<el-radio-group v-model="value.biaoqian" size="medium">
							<el-radio-button label="xinpin">最新</el-radio-button>
							<el-radio-button label="tuijian">时间</el-radio-button>
						</el-radio-group>
					</div>
				</div> -->
				
			</div>
		</el-tab-pane>
		<el-tab-pane>
			<span slot="label"><i class="el-icon-menu"></i> 组件样式</span>
			<!-- <el-input placeholder="请输入内容" v-model="value.yangshi.gao">
				<template slot="prepend">Http://</template>
			</el-input> -->
		</el-tab-pane>
	</el-tabs>
</template>

<script>
	export default {
		name: 'jianzhi_bianji',
		props: {
			value: {
				type: [Object, Array],
				default () {
					return {}
				}
			}
		},


	}
</script>
<link rel="stylesheet" href="Yangshi.css">
